import axios from 'axios';

const AuthStorageKeys = ['auth_token', 'access_token', 'refresh_token', 'last_refreshed_at'];

export const clearAuthSession = () => {
    AuthStorageKeys.forEach((key) => localStorage.removeItem(key));
    axios.defaults.headers.common.Authorization = undefined;
};

export const expireAuthSession = () => {
    clearAuthSession();

    if (window.location.pathname !== '/') {
        window.location.href = '/';
    }
};
